var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThinq24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 26,
    viewBox: "0 0 110 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2097_1030)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2074 19.626C78.6359 17.7536 79.4928 15.4283 79.4928 12.8988C79.4928 6.73208 74.4586 1.7334 68.2489 1.7334C67.3574 1.7334 66.4956 1.84643 65.6651 2.04085V6.87039C66.4574 6.53422 67.3314 6.34724 68.2489 6.34724C71.8911 6.34724 74.8464 9.28047 74.8464 12.8988C74.8464 14.2408 74.4375 15.4871 73.7403 16.5257L74.1798 20.2919L70.148 19.172C69.5456 19.3499 68.9086 19.4504 68.2489 19.4504C64.605 19.4504 61.6501 16.5172 61.6501 12.8988C61.6501 12.5664 61.6826 12.2416 61.7314 11.9217H57.0525C57.0241 12.2441 57.0029 12.5691 57.0029 12.8988C57.0029 19.064 62.0375 24.064 68.2485 24.064C69.3867 24.064 70.4846 23.8935 71.5224 23.5813L71.52 23.5826L77.896 25.3547L77.2269 19.6206C77.2269 19.6206 77.2135 19.6246 77.2074 19.626Z",
    fill: "#ED1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5597 1.25391H61.0361V4.75284H64.5597V1.25391Z",
    fill: "#ED1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2272 6.52148H59.041V9.68451H62.2272V6.52148Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0426 3.27539H57.0068V5.29319H59.0426V3.27539Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1251 6.51758H56.0918V8.53806H58.1251V6.51758Z",
    fill: "#ED1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2716 10.0469H54.7793V11.5291H56.2716V10.0469Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3223 1.03612H58.832V2.51697H60.3223V1.03612Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8739 1.50098H55.7881V2.57704H56.8739V1.50098Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9053 25.5333C81.9162 24.503 82.1382 23.6296 82.5707 22.9134C83.0024 22.1974 83.7699 21.4716 84.8728 20.736C85.0402 20.6238 85.2829 20.4677 85.602 20.2695C87.0606 19.3416 87.791 18.448 87.791 17.5895C87.791 17.0799 87.6366 16.6772 87.3284 16.3818C87.0203 16.0873 86.5992 15.9392 86.0646 15.9392C85.4805 15.9392 85.0301 16.1206 84.7146 16.4828C84.398 16.8445 84.2402 17.3615 84.2402 18.0323V18.1288H82.1C82.1 16.8089 82.4569 15.7918 83.1703 15.078C83.8837 14.3645 84.9 14.0078 86.2183 14.0078C87.413 14.0078 88.3667 14.3315 89.0797 14.9778C89.7931 15.6243 90.15 16.4839 90.15 17.5568C90.15 18.3243 89.963 18.9897 89.5902 19.5528C89.2175 20.1163 88.4959 20.7578 87.426 21.4764C87.1992 21.632 86.8854 21.8358 86.4858 22.0884C85.4691 22.7373 84.8967 23.231 84.7671 23.5687H90.0358V25.5328H81.9053V25.5333Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2123 25.5333V23.0464H91.3164V21.0176L95.5957 14.3379H98.4737V21.211H99.8192V23.0464H98.4737V25.5333H96.2123ZM96.2611 21.2674V16.3339L93.1079 21.2674H96.2611Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9946 9.0957C45.047 9.0957 43.3344 9.91594 42.184 11.264V9.44679H41.0324C40.3838 9.44679 39.8524 9.62365 39.4096 10.0625C38.9963 10.4726 38.79 10.9705 38.79 11.7042V25.5633H42.3613V16.158C42.3613 14.0484 43.8064 12.4657 46.0202 12.4657C48.2633 12.4657 49.8568 14.0484 49.8568 16.158V25.5635H53.4279V15.3665C53.4283 11.9087 50.5365 9.0957 46.9946 9.0957Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1928 9.09601C21.2446 9.09601 19.5328 9.91621 18.3818 11.2644V1.1125H17.2308C16.582 1.1125 16.0501 1.28803 15.6073 1.7282C15.1945 2.1383 14.9883 2.63617 14.9883 3.36862V25.5638H18.5588V16.1583C18.5588 14.0487 20.0047 12.466 22.2183 12.466C24.4616 12.466 26.0545 14.0487 26.0545 16.1583V25.5638H29.6262V15.3668C29.6264 11.909 26.7341 9.09601 23.1928 9.09601Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9322 9.44734H34.6066C33.9573 9.44734 33.4264 9.6242 32.9836 10.063C32.5698 10.4731 32.3633 10.971 32.3633 11.7048V25.5638H35.9421L35.9322 9.44734Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9499 6.16369C35.9499 7.14188 35.1511 7.93575 34.1644 7.93575C33.1786 7.93575 32.3799 7.14188 32.3799 6.16369C32.3799 5.18547 33.1786 4.3916 34.1644 4.3916C35.1509 4.3916 35.9499 5.18547 35.9499 6.16369Z",
    fill: "#655A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8066 22.0296C11.1222 22.3745 10.335 22.6179 9.65005 22.6179C8.00675 22.6179 7.21923 21.6158 7.21923 19.8229V11.4301H12.1826V8.35992H7.25513V8.35246H7.14533V1.1123H5.99407C5.34533 1.1123 4.81391 1.28784 4.37086 1.728C3.95782 2.1381 3.75184 2.63597 3.75184 3.36842V8.35218H3.69586V8.35964H0.444336V11.4301H3.69586V19.8232C3.69586 23.8251 5.78326 25.9288 9.44541 25.8253C10.6441 25.8253 11.67 25.5833 12.8327 25.066L11.8066 22.0296Z",
    fill: "#655A65"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.836 0.964844H101.777L103.35 4.72858L104.919 0.964844H105.864L103.725 5.96484H102.97L100.836 0.964844ZM100.361 0.964844H101.282L101.448 4.42295V5.96484H100.361V0.964844ZM105.413 0.964844H106.338V5.96484H105.251V4.42295L105.413 0.964844Z",
    fill: "#655A65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8502 0.964844V5.96484H96.767V0.964844H97.8502ZM99.6369 0.964844V1.71004H95V0.964844H99.6369Z",
    fill: "#655A65"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2097_1030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 25,
    fill: "white",
    transform: "translate(0 0.964844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinq24);
export default __webpack_public_path__ + "static/media/thinq24.fc47f2ed018cec6878ad7d34f3d128eb.svg";
export { ForwardRef as ReactComponent };